"use client";

import { c as _c } from "react/compiler-runtime";
import NumberFlow from "@number-flow/react";
import { useEffect, useState } from "react";
import { incrementViews } from "@/lib/server/views";
const ViewCounter = t0 => {
  const $ = _c(7);
  const {
    slug
  } = t0;
  const [views, setViews] = useState(null);
  const [error, setError] = useState(false);
  let t1;
  let t2;
  if ($[0] !== slug) {
    t1 = () => {
      incrementViews(slug).then(hits => {
        setViews(hits);
      }).catch(err => {
        console.error("[view-counter] error:", err);
        setError(true);
      });
    };
    t2 = [slug];
    $[0] = slug;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  if (error) {
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <span title="Error getting views! :(">?</span>;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    return t3;
  }
  const t3 = views === null ? "motion-safe:animate-pulse" : undefined;
  const t4 = views ?? 0;
  let t5;
  if ($[4] !== t3 || $[5] !== t4) {
    t5 = <NumberFlow className={t3} locales={process.env.NEXT_PUBLIC_SITE_LOCALE} value={t4} />;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export { ViewCounter };